import {HttpClient} from '@angular/common/http';
import {Injectable} from '@angular/core';
import {HttpProvider} from "../http/http";

/*
  Generated class for the ZoneProvider provider.

  See https://angular.io/guide/dependency-injection for more info on providers
  and Angular DI.
*/
@Injectable()
export class ZoneProvider {

  constructor(public http: HttpProvider) {
    console.log('Hello ZoneProvider Provider');
  }



  /**
   * 获取群空间数据*/
  getSourceList(chatroomname, keyword, real_type, page, pagesize, order_type) {
    let params = {
      chatroomname: chatroomname,
      keyword: keyword,
      real_type: keyword ? 0 : real_type,
      page: page,
      pagesize: pagesize,
      order_type: order_type ? 'asc' : 'desc'
    };
    return this.http.hPost('/clientchatroom/get_resource_detail', params);
  }

  /**
   * 获取每一类里面的总数，用于直接跳到目标type*/
  getSourceCount(){
    return this.http.hPost('/clientchatroom/get_resources_stats');
  }
}



// WEBPACK FOOTER //
// ./src/providers/zone/zone.ts